import { render } from "./HelpDeskInquiry.vue?vue&type=template&id=dba696f2&scoped=true"
import script from "./HelpDeskInquiry.vue?vue&type=script&lang=js"
export * from "./HelpDeskInquiry.vue?vue&type=script&lang=js"

import "./HelpDeskInquiry.vue?vue&type=style&index=0&id=dba696f2&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-dba696f2"]])

export default __exports__